<template>
  <div class="animated fadeInRight">
    <BreadCrumbs title="Мои документы" :items="[{title: 'Главная', url: '/admin/'}, {title: 'Профиль', url: '/admin/profile'}]"/>
    <div class="wrapper wrapper-content">

      <div v-if="loading" class="text-center text-muted p-xl">
        <i class="fa fa-spinner fa-spin"></i> Загрузка…
      </div>

      <div v-else-if="!documents.length" class="ibox">
        <div class="ibox-content text-center text-muted p-xl">
          <i class="fa fa-folder-open-o fa-2x"></i>
          <p class="m-t-sm">Документы пока не назначены.</p>
        </div>
      </div>

      <b-row v-else>
        <b-col v-for="doc in documents" :key="doc.id" xl="4" lg="6" md="6" cols="12">
          <div class="ibox">
            <div class="ibox-title">
              <h3 class="m-0">{{ doc.title }}</h3>
            </div>
            <div class="ibox-content">
              <p v-if="doc.description" class="text-muted document-description">{{ doc.description }}</p>

              <p v-if="doc.deadline" class="m-b-sm">
                <i class="fa fa-clock-o"></i>
                Дедлайн загрузки:
                <strong :class="{'text-danger': doc.isOverdue}">{{ doc.deadline | formatDate('DD.MM.YYYY') }}</strong>
                <b-badge v-if="doc.isOverdue" variant="danger" class="m-l-xs">Просрочено</b-badge>
              </p>

              <hr class="hr-line-dashed m-t-sm m-b-sm"/>

              <!-- Шаблон от администратора -->
              <div class="m-b-sm">
                <small class="text-muted text-uppercase">Шаблон</small><br/>
                <b-button
                    v-if="doc.hasTemplate"
                    variant="white"
                    size="sm"
                    @click="downloadFile(doc.templateDownloadPath, doc.templateName)">
                  <i class="fa fa-download"></i> Скачать{{ doc.templateName ? ' (' + doc.templateName + ')' : '' }}
                </b-button>
                <span v-else class="text-muted"><i class="fa fa-minus"></i> Шаблон не приложен</span>
              </div>

              <hr class="hr-line-dashed m-t-sm m-b-sm"/>

              <!-- Подписанная копия слушателя -->
              <div>
                <small class="text-muted text-uppercase">Моя подписанная копия</small>

                <div v-if="doc.hasSubmission" class="m-t-xs m-b-sm">
                  <i class="fa fa-check-circle text-navy"></i>
                  Загружено <span v-if="doc.submittedAt" class="text-muted">({{ doc.submittedAt | formatDate('DD.MM.YYYY HH:mm') }})</span>
                  <br/>
                  <b-button
                      variant="white"
                      size="sm"
                      class="m-t-xs"
                      @click="downloadFile(doc.submissionDownloadPath, doc.submissionName)">
                    <i class="fa fa-download"></i> {{ doc.submissionName || 'Скачать копию' }}
                  </b-button>
                </div>

                <b-form-file
                    class="m-t-xs"
                    :value="null"
                    :disabled="doc._uploading"
                    accept=".pdf,.doc,.docx"
                    :browse-text="doc._uploading ? 'Загрузка…' : (doc.hasSubmission ? 'Заменить' : 'Выбрать')"
                    :placeholder="doc.hasSubmission ? 'Загрузить другой файл (PDF/Word)' : 'Загрузить файл (PDF/Word)'"
                    drop-placeholder="Перетащите файл сюда…"
                    @input="(file) => uploadSubmission(doc, file)"/>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>

    </div>
  </div>
</template>

<script>
import BreadCrumbs from "../BreadCrumbs";

const ALLOWED_EXT = ['pdf', 'doc', 'docx'];

export default {
  name: "MyDocuments",
  components: {BreadCrumbs},
  data() {
    return {
      documents: [],
      loading: true,
    }
  },
  mounted() {
    this.loadDocuments();
  },
  methods: {
    loadDocuments() {
      this.loading = true;
      this.axios.get('student_documents/my').then(res => {
        this.documents = (res.data || []).map(d => ({...d, _uploading: false}));
      }).finally(() => {
        this.loading = false;
      });
    },
    uploadSubmission(doc, file) {
      if (!file) return;

      const ext = (file.name.split('.').pop() || '').toLowerCase();
      if (ALLOWED_EXT.indexOf(ext) === -1) {
        this.$toasted.global.appError('Допустимы только файлы Word и PDF (.pdf, .doc, .docx)');
        return;
      }

      const fd = new FormData();
      fd.append('file', file);

      this.$set(doc, '_uploading', true);
      this.axios.post(`student_documents/${doc.id}/submission`, fd, {
        headers: {'Content-Type': 'multipart/form-data'}
      }).then(res => {
        this.$set(doc, 'hasSubmission', true);
        this.$set(doc, 'submissionName', res.data.submissionName);
        this.$set(doc, 'submittedAt', res.data.submittedAt);
        this.$set(doc, 'submissionDownloadPath', res.data.submissionDownloadPath);
        this.$toasted.global.appSuccess('Файл успешно загружен');
      }).catch(() => {
        this.$toasted.global.appError('Не удалось загрузить файл');
      }).finally(() => {
        this.$set(doc, '_uploading', false);
      });
    },
    downloadFile(path, fileName) {
      if (!path) return;
      this.axios.get(path, {responseType: 'blob'}).then(res => {
        const blob = new Blob([res.data], {type: res.headers['content-type'] || 'application/octet-stream'});
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName || 'document';
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      }).catch(() => {
        this.$toasted.global.appError('Не удалось скачать файл');
      });
    }
  }
}
</script>

<style scoped>
.document-description {
  white-space: pre-line;
}
.p-xl {
  padding: 40px 20px;
}
</style>
